import { render, staticRenderFns } from "./LeagueScreen.vue?vue&type=template&id=14c72320&scoped=true"
import script from "./LeagueScreen.vue?vue&type=script&lang=js"
export * from "./LeagueScreen.vue?vue&type=script&lang=js"
import style0 from "./LeagueScreen.vue?vue&type=style&index=0&id=14c72320&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c72320",
  null
  
)

export default component.exports